// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminChatUserLayout_wrapper__NWFh-","loader":"AdminChatUserLayout_loader__PbwFu","placeholder":"AdminChatUserLayout_placeholder__iHa76"};